import { ArrowUpRight } from "lucide-react";
import { waLink } from "../lib/site";

export const ProductShot = ({ p, className = "", field = false, scale = 0.94 }) => (
  <div className={`stage relative overflow-hidden ${field ? "stage-field" : ""} ${className}`}>
    {field && <img src="/img/campo.jpg" alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover" />}
    {field && <div className="absolute inset-0 bg-white/20" />}
    <img src={p.img} alt={`${p.name} SOLLUS`} loading="lazy"
      style={{ height: `${scale * 100}%`, width: `${scale * 100}%` }}
      className="absolute inset-0 m-auto object-contain drop-shadow-[0_18px_18px_rgba(17,24,39,0.18)] transition-transform duration-700 ease-out group-hover:-translate-y-1 group-hover:scale-[1.05]" />
  </div>
);

export const ProductCard = ({ p, tall = false }) => (
  <article id={p.slug} data-testid={`product-card-${p.slug}`}
    className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-line bg-white transition-shadow duration-500 hover:shadow-[0_24px_60px_-30px_rgba(17,24,39,0.45)]">
    <ProductShot p={p} className={tall ? "aspect-[4/3] lg:aspect-auto lg:flex-1" : "aspect-[4/3]"} />
    <span className="absolute left-3 top-3 rounded-sm bg-white px-2 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-ink">{p.category}</span>
    <div className="flex items-end justify-between gap-4 border-t border-line p-5">
      <div>
        <h3 className="font-display text-2xl font-bold uppercase leading-none text-ink">{p.name}</h3>
        <p className="mt-1 text-xs text-steel">{p.model}</p>
        {tall && <p className="mt-2 max-w-sm text-sm text-steel">{p.desc}</p>}
      </div>
      <a href={waLink(`Olá, SOLLUS! Gostaria de um orçamento para: ${p.model}.`)} target="_blank" rel="noreferrer"
        data-testid={`product-quote-btn-${p.slug}`} aria-label={`Orçamento ${p.name}`}
        className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-brand text-white transition-transform duration-300 group-hover:rotate-45 hover:bg-brand-dark">
        <ArrowUpRight className="h-5 w-5" />
      </a>
    </div>
  </article>
);
